import { Component } from '@angular/core';
import { BaseComponent, ValidationHandlerService } from 'lib/Vestra.shared';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { CoreService, VersionInfoModel, VersionInfoModelListBaseResponse } from 'src/app/services/api-services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
    templateUrl: './version-info.component.html',
    styleUrls: ['./version-info.component.scss'],
})
export class VersionInfoComponent extends BaseComponent {
    constructor(private router: Router, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public versionInfos: VersionInfoModel[] = [];

    public markdown = '';

    public ngOnInit() {
        this.spinnerService.show();
        this.handleSpinner(
            firstValueFrom(this.coreService.getVersionInfos())
                .then((res: VersionInfoModelListBaseResponse) => {
                    this.versionInfos = res.result;

                    for (let i = 0; i < this.versionInfos.length; i++) {
                        this.markdown += this.versionInfos[i].versionText;
                    }
                    return Promise.resolve(res);
                })
                .catch(error => {
                    this.validationHandlerService.handleServerError(error);
                })
                .finally(() => {
                    this.spinnerService.hide();
                })
        );
    }
}
